"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AvatarEnum;
(function (AvatarEnum) {
    // K-5
    AvatarEnum["JOE"] = "svg:Joe";
    AvatarEnum["ROCKY"] = "svg:Rocky";
    AvatarEnum["HAPPY"] = "svg:Happy";
    AvatarEnum["DAISY"] = "svg:Daisy";
    AvatarEnum["MEL"] = "svg:Mel";
    AvatarEnum["JUNE"] = "svg:June";
    AvatarEnum["SID"] = "svg:Sid";
    AvatarEnum["ROSE"] = "svg:Rose";
    AvatarEnum["LILY"] = "svg:Lily";
    AvatarEnum["JOSEPH"] = "svg:Joseph";
    AvatarEnum["HANK"] = "svg:Hank";
    AvatarEnum["JG"] = "svg:JG";
    AvatarEnum["ROCKET"] = "svg:Rocket";
    AvatarEnum["SPARKLE"] = "svg:Sparkle";
    AvatarEnum["SUNNY"] = "svg:Sunny";
    AvatarEnum["HARRYK5"] = "svg:HarryK5";
    AvatarEnum["TULIP"] = "svg:Tulip";
    AvatarEnum["CLYDE"] = "svg:Clyde";
    AvatarEnum["CRABBY"] = "svg:Crabby";
    AvatarEnum["CHUCK"] = "svg:Chuck";
    AvatarEnum["FUZZY"] = "svg:Fuzzy";
    // Not used
    AvatarEnum["LEGS"] = "svg:Legs";
    //POPPY = "svg:Poppy",
    // 6-8
    AvatarEnum["OTTO"] = "png:Otto";
    AvatarEnum["TANGO"] = "png:Tango";
    AvatarEnum["SMOKY"] = "png:Smoky";
    AvatarEnum["GADGET"] = "png:Gadget";
    AvatarEnum["MEG"] = "png:Meg";
    AvatarEnum["RED"] = "png:Red";
    AvatarEnum["SKY"] = "png:Sky";
    AvatarEnum["MO"] = "png:Mo";
    AvatarEnum["NANO"] = "png:Nano";
    AvatarEnum["HARRY"] = "png:Harry";
    AvatarEnum["SMILEY"] = "png:Smiley";
    AvatarEnum["PIXEL"] = "png:Pixel";
    AvatarEnum["RUBY"] = "png:Ruby";
    AvatarEnum["SPIKE"] = "png:Spike";
    AvatarEnum["IGGY"] = "png:Iggy";
    AvatarEnum["MILES"] = "png:Miles";
    AvatarEnum["REX"] = "png:Rex";
    AvatarEnum["KAI"] = "png:Kai";
    AvatarEnum["OAKLEY"] = "png:Oakley";
    AvatarEnum["LENNY"] = "png:Lenny";
    AvatarEnum["ZELDA"] = "png:Zelda";
    // 9-12
    AvatarEnum["CAT"] = "png:Cat";
    AvatarEnum["GRIZZLY"] = "png:Grizzly";
    AvatarEnum["LION"] = "png:Lion";
    AvatarEnum["SHARK"] = "png:Shark";
    AvatarEnum["MONKEY"] = "png:Monkey";
    AvatarEnum["HORSE"] = "png:Horse";
    AvatarEnum["PANDA"] = "png:Panda";
    AvatarEnum["ELK"] = "png:Elk";
    AvatarEnum["FOX"] = "png:Fox";
    AvatarEnum["RACCOON"] = "png:Raccoon";
    AvatarEnum["GIRAFFE"] = "png:Giraffe";
    AvatarEnum["ACE"] = "png:Ace";
    AvatarEnum["CALVIN"] = "png:Calvin";
    AvatarEnum["DASH"] = "png:Dash";
    AvatarEnum["DENVER"] = "png:Denver";
    AvatarEnum["HARLEY"] = "png:Harley";
    AvatarEnum["OLLIE"] = "png:Ollie";
    AvatarEnum["DUKE"] = "png:Duke";
    AvatarEnum["HUX"] = "png:Hux";
    AvatarEnum["REMY"] = "png:Remy";
    AvatarEnum["SONNY"] = "png:Sonny";
    // ABLD
    AvatarEnum["ABLD_ALLIGATOR"] = "png:ABLD_Alligator";
    AvatarEnum["ABLD_BIRD"] = "png:ABLD_Bird";
    AvatarEnum["ABLD_BROWN_BEAR"] = "png:ABLD_Brown_Bear";
    AvatarEnum["ABLD_BUTTERFLY"] = "png:ABLD_Butterfly";
    AvatarEnum["ABLD_CAT"] = "png:ABLD_Cat";
    AvatarEnum["ABLD_CLOWNFISH"] = "png:ABLD_Clownfish";
    AvatarEnum["ABLD_DOG"] = "png:ABLD_Dog";
    AvatarEnum["ABLD_DOLPHIN"] = "png:ABLD_Dolphin";
    AvatarEnum["ABLD_ELEPHANT"] = "png:ABLD_Elephant";
    AvatarEnum["ABLD_FROG"] = "png:ABLD_Frog";
    AvatarEnum["ABLD_GIRAFFE"] = "png:ABLD_Giraffe";
    AvatarEnum["ABLD_GOLDFISH"] = "png:ABLD_Goldfish";
    AvatarEnum["ABLD_GOOSE"] = "png:ABLD_Goose";
    AvatarEnum["ABLD_HAMSTER"] = "png:ABLD_Hamster";
    AvatarEnum["ABLD_HORSE"] = "png:ABLD_Horse";
    AvatarEnum["ABLD_IGUANA"] = "png:ABLD_Iguana";
    AvatarEnum["ABLD_KOALA_BEAR"] = "png:ABLD_Koala_Bear";
    AvatarEnum["ABLD_LEOPARD"] = "png:ABLD_Leopard";
    AvatarEnum["ABLD_LION"] = "png:ABLD_Lion";
    AvatarEnum["ABLD_MONKEY"] = "png:ABLD_Monkey";
    AvatarEnum["ABLD_ORCA_WHALE"] = "png:ABLD_Orca_Whale";
    AvatarEnum["ABLD_PANDA_BEAR"] = "png:ABLD_Panda_Bear";
    AvatarEnum["ABLD_PARROT"] = "png:ABLD_Parrot";
    AvatarEnum["ABLD_PENGUIN"] = "png:ABLD_Penguin";
    AvatarEnum["ABLD_RABBIT"] = "png:ABLD_Rabbit";
    AvatarEnum["ABLD_RACOON"] = "png:ABLD_Racoon";
    AvatarEnum["ABLD_SEA_TURTLE"] = "png:ABLD_Sea_Turtle";
    AvatarEnum["ABLD_SEAHORSE"] = "png:ABLD_Seahorse";
    AvatarEnum["ABLD_SHARK"] = "png:ABLD_Shark";
    AvatarEnum["ABLD_SHEEP"] = "png:ABLD_Sheep";
    AvatarEnum["ABLD_SHELL"] = "png:ABLD_Shell";
    AvatarEnum["ABLD_SLOTH"] = "png:ABLD_Sloth";
    AvatarEnum["ABLD_STARFISH"] = "png:ABLD_Starfish";
    AvatarEnum["ABLD_TIGER"] = "png:ABLD_Tiger";
    AvatarEnum["ABLD_TURTLE"] = "png:ABLD_Turtle";
    AvatarEnum["ABLD_ZEBRA"] = "png:ABLD_Zebra";
})(AvatarEnum || (AvatarEnum = {}));
exports.default = AvatarEnum;
